<template>
  <div class="input-group date date-picker" style="width: 200px">
    <span class="input-group-btn">
      <button class="btn blue" type="button" tabindex="-1" @click="previousDay" :disabled="disabled">
        <i class="fa fa-arrow-left"></i>
      </button>
    </span>
    <input :name="name" type="text" :value="defaultDate" @change="onChange" ref="date-picker" class="no-focus form-control form-control-inline input_placeholder" :placeholder="placeholder" :disabled="disabled" />
    <span class="input-group-btn">
      <button class="btn blue" type="button" tabindex="-1" @click="nextDay" :disabled="disabled">
        <i class="fa fa-arrow-right"></i>
      </button>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    defaultDate: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    placeholderFormat: {
      type: String,
      default: "",
    },
    value: {},
  },
  data() {
    return {
      datePicker: undefined,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let _this = this;
      let input = this.$refs["date-picker"];
      this.datePicker = $(input).datepicker({
        rtl: App.isRTL(),
        orientation: "right",
        format: this.placeholderFormat,
        autoclose: true,
        todayHighlight: true,
      });

      this.datePicker.on("changeDate", (e) => {
        _this.$emit("input", input.value);
      });
    },
    onChange(event) {
      this.$emit("input", input.value);
    },
    previousDay() {
      let input = this.$refs["date-picker"];
      let date = $(input).datepicker("getDate");
      let newdate = date.addDays(-1);
      $(input).datepicker("setDate", newdate);
    },
    nextDay() {
      let input = this.$refs["date-picker"];
      let date = $(input).datepicker("getDate");
      let newdate = date.addDays(1);
      $(input).datepicker("setDate", newdate);
    },
  },
};
</script>